import { create } from "zustand";
import { devtools } from "zustand/middleware";

import type { ProductCategory } from "~/providers/product-provider";

interface ProductCategoryStoreState {
  isLoading: boolean;
  productCategoryFormOpen: boolean;
  currentProductCategory?: ProductCategory;
  setIsLoading: (loading: boolean) => void;
  setCurrentProductCategory: (category?: ProductCategory) => void;
  setProductCategoryFormOpen: (open: boolean) => void;
}

export const useProductCategoryStore = create<ProductCategoryStoreState>()(
  devtools((set) => ({
    isLoading: false,
    productCategoryFormOpen: false,
    setIsLoading: (loading) => {
      set(() => ({ isLoading: loading }));
    },
    setCurrentProductCategory: (category) => {
      set(() => ({ currentProductCategory: category }));
    },
    setProductCategoryFormOpen: (open) => {
      set(() => ({ productCategoryFormOpen: open }));
    },
  })),
);
